module.exports = __webpack_public_path__ + "static/media/head-phones.ef1ae7d9.png";